export { default as StrategyInfoButton } from './StrategyInfoButton';
